module.exports = __webpack_public_path__ + "static/img/医嘱与病历_场景三.ad2d4255.png";